import React from 'react';
import useImportRowsInfos
    from "v4/pages/admin/Import/components/ImportSteps/components/ImportRowsInfos/hooks/useImportRowsInfos";
import PolInfoBox from "v4/components/ui/PolInfoBox/PolInfoBox";
import FormRender from "v4/components/form/FormRender/FormRender";
import ImportRowsInfosSelectIdentifiers
    from "v4/pages/admin/Import/components/ImportSteps/components/ImportRowsInfos/components/ImportRowsInfosSelectIdentifiers/ImportRowsInfosSelectIdentifiers";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

export default function ImportRowsInfosMapping({fullData, identifierFormMethods, form}) {
    const {t} = usePolTranslation();
    const {
        unmappedColumns,
        totalColumns,
        selectIdentifierManager,
    } = useImportRowsInfos(fullData, identifierFormMethods, form);

    return (
        <>
            {unmappedColumns !== undefined && (
                <PolInfoBox icon={unmappedColumns === 0 ? 'validation' : 'warning'}
                            title={t('total_mapped_columns')}
                            text={`${totalColumns - unmappedColumns} / ${totalColumns}`}
                            isIconSuccess={unmappedColumns === 0}
                            isIconWarning={unmappedColumns !== 0}/>
            )}
            {selectIdentifierManager && (
                <FormRender form={selectIdentifierManager.form}
                            methods={selectIdentifierManager.methods}
                            formRender={() => (
                                <ImportRowsInfosSelectIdentifiers/>
                            )}
                />
            )}
        </>
    )
}
